// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function delivery_note_detail_encode(v) {
  return Js_dict.fromArray([
              [
                "status",
                Decco.stringToJson(v.status)
              ],
              [
                "dn_type",
                Decco.stringToJson(v.dn_type)
              ]
            ]);
}

function delivery_note_encode(v) {
  return Js_dict.fromArray([
              [
                "is_requested",
                Decco.boolToJson(v.is_requested)
              ],
              [
                "details",
                Decco.listToJson(delivery_note_detail_encode, v.details)
              ],
              [
                "comments",
                Decco.optionToJson(Decco.stringToJson, v.comments)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "crn",
                Decco.stringToJson(v.crn)
              ],
              [
                "admin_id",
                Decco.intToJson(v.admin_id)
              ],
              [
                "admin_name",
                Decco.stringToJson(v.admin_name)
              ],
              [
                "delivery_note",
                delivery_note_encode(v.delivery_note)
              ]
            ]);
}

export {
  delivery_note_detail_encode ,
  delivery_note_encode ,
  t_encode ,
  
}
/* No side effect */
